module.exports = __webpack_public_path__ + "static/img/cocktail.f6cfaf3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cocktail.gif
// module id = 7/5U
// module chunks = 4